import { API_BASE_URL } from './config';
const LOCAL_API_URL = `${API_BASE_URL}/packages`;

export interface CMSPackageCreate {
  package_id: string;
  name: string;
  name_en?: string;
  category: string;
  category_en?: string;
  price?: number;
  original_price?: number;
  show_price?: boolean;
  badge?: string;
  badge_en?: string;
  icon?: string;
  features?: any[];
  features_en?: any[];
  accent_color?: string;
  description?: string;
  description_en?: string;
  duration?: string;
  duration_en?: string;
  target_audience?: string;
  target_audience_en?: string;
  preparation?: string[];
  preparation_en?: string[];
  includes?: { label: string; icon: string }[];
  includes_en?: { label: string; icon: string }[];
  faqs?: any[];
  is_active?: boolean;
}

export interface CMSPackageUpdate extends Partial<CMSPackageCreate> {}

export interface CMSPackageResponse extends CMSPackageCreate {
  id: string;
  is_active?: boolean;
  created_at: string;
  updated_at: string;
}

// ─── API Functions ────────────────────────────────────────────────────────────

export async function getPackages(skip = 0, limit = 100): Promise<CMSPackageResponse[]> {
  const res = await fetch(`${LOCAL_API_URL}/?skip=${skip}&limit=${limit}`);
  if (!res.ok) throw new Error("Failed to fetch packages");
  return res.json();
}

export async function getPackageById(id: string): Promise<CMSPackageResponse> {
  const res = await fetch(`${LOCAL_API_URL}/${id}`);
  if (!res.ok) throw new Error("Failed to fetch package details");
  return res.json();
}

export async function createPackage(data: CMSPackageCreate): Promise<CMSPackageResponse> {
  const token = localStorage.getItem("access_token");
  const res = await fetch(`${LOCAL_API_URL}/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`
    },
    body: JSON.stringify(data),
  });

  if (res.status === 401) {
    window.dispatchEvent(new CustomEvent("auth-error"));
    throw new Error("انتهت جلسة الدخول");
  }

  if (!res.ok) {
    const errorData = await res.json().catch(() => null);
    throw new Error(errorData?.detail || "Failed to create package");
  }

  return res.json();
}

export async function updatePackage(id: string, data: CMSPackageUpdate): Promise<CMSPackageResponse> {
  const token = localStorage.getItem("access_token");
  const res = await fetch(`${LOCAL_API_URL}/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`
    },
    body: JSON.stringify(data),
  });

  if (res.status === 401) {
    window.dispatchEvent(new CustomEvent("auth-error"));
    throw new Error("انتهت جلسة الدخول");
  }

  if (!res.ok) {
    const errorData = await res.json().catch(() => null);
    throw new Error(errorData?.detail || "Failed to update package");
  }

  return res.json();
}

export async function deletePackage(id: string): Promise<{ message: string }> {
  const token = localStorage.getItem("access_token");
  const res = await fetch(`${LOCAL_API_URL}/${id}`, {
    method: "DELETE",
    headers: {
      "Authorization": `Bearer ${token}`
    },
  });

  if (res.status === 401) {
    window.dispatchEvent(new CustomEvent("auth-error"));
    throw new Error("انتهت جلسة الدخول");
  }

  if (!res.ok) {
    const errorData = await res.json().catch(() => null);
    throw new Error(errorData?.detail || "Failed to delete package");
  }

  return res.json();
}

